import React, { useImperativeHandle, useRef } from 'react';

import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';

import TextField from '../inputs/TextField';

const FormNumberTextField = React.forwardRef((props, fRef) => {
    const { name, defaultValue, onIsValidListener, digit, ...textFieldProps } = props;
    const { trigger, control } = useFormContext();

    const inputRef = useRef();
    useImperativeHandle(fRef, () => ({
        focus: () => {
            inputRef.current.focus();
        },
    }));

    return (
        <Controller
            render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => {
                const handleOnChange = async ({ target: { value } }) => {
                    if (value?.length <= digit) {
                        onChange(value);
                    }

                    if (value?.length === digit) {
                        const valid = await trigger(name);
                        if (valid) {
                            onIsValidListener?.();
                        }
                    }
                };

                return (
                    <TextField
                        error={!!error}
                        onChange={handleOnChange}
                        onBlur={onBlur}
                        value={value}
                        inputRef={inputRef}
                        helperText={error?.message}
                        {...textFieldProps}
                        sx={{ mb: 2 }}
                    />
                );
            }}
            name={name}
            control={control}
            defaultValue={defaultValue || ''}
        />
    );
});

FormNumberTextField.propTypes = {
    name: PropTypes.string.isRequired,
    defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    autoTrigger: PropTypes.bool,
    onIsValidListener: PropTypes.func,
    digit: PropTypes.number.isRequired,
};

export default FormNumberTextField;
